import { Select, Option } from '@mui/joy';
import { KeyboardArrowDown } from '@mui/icons-material';
import { MEAL_TYPE_LABELS } from '@/features/meals/constants';

// "default" fills its container like any other form field. "header" renders the
// picker inline inside a heading: it inherits the surrounding text's font so it
// reads as part of the caption rather than as a control dropped into it.
const VARIANT_PROPS = {
  default: {
    sx: { width: '100%' },
    slotProps: { listbox: { sx: { width: '100%' } } },
  },
  header: {
    variant: 'plain',
    color: 'primary',
    indicator: <KeyboardArrowDown />,
    sx: {
      fontFamily: 'inherit',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      lineHeight: 'inherit',
      minHeight: 0,
      py: 0,
      px: 0.5,
    },
  },
};

export function MealTypePicker({ value, onChange, variant = 'default' }) {
  return (
    <Select
      value={value}
      onChange={(e, mealType) => mealType && onChange(mealType)}
      {...VARIANT_PROPS[variant]}
    >
      {Object.entries(MEAL_TYPE_LABELS).map(([mealType, label]) => (
        <Option key={mealType} value={mealType}>{label}</Option>
      ))}
    </Select>
  );
}
